require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-michelle-ferreirae.json") })
        }
      }, "path---blog-author-michelle-ferreirae");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-michelle-ferreirae!./.cache/json/blog-author-michelle-ferreirae.json
// module id = 683
// module chunks = 231608221292675